<template>
  <div v-if="currentTiers">
    <div class="row">
      <div class="col-lg-12">
        <BreadCrumd
          :title="'Tiers'"
          :description="'Modification d\'un tiers'"
        />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push({ name: 'crm_tiers' }).catch(() => {})"
        >
          Liste des tiers
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'crm_tiers-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouveau tiers
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'crm_tiers-show',
                params: { id: currentTiers.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit',
                params: { id: currentTiers.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-edit text-custom-primary font-size-17"></i>
              Tiers</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit-contact',
                params: { id: currentTiers.id },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Contacts</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit-banque',
                params: {
                  id: currentTiers.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Comptes Bancaires</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit-note',
                params: {
                  id: currentTiers.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Notes</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit-param',
                params: {
                  id: currentTiers.id,
                },
              }"
              exact
              exact-active-class="active"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Autres informations</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'crm_tiers-edit-reseau',
                params: { id: currentTiers.id },
              }"
              exact
              exact-active-class="active"
              ><i class="mdi mdi-web text-custom-primary font-size-17"></i>
              Reseau</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'Gestion des Tiers - Edition',
    };
  },

  computed: {
    ...mapGetters('tiers', ['currentTiers']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('tiers', ['getTiers']),
    init() {
      this.getTiers(this.$route.params.id);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
